import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['scrollArea', 'pagination'];

  initialize() {
    this.loading = false;

    let options = {
      rootMargin: '200px',
    };

    this.intersectionObserver = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      options,
    );
  }

  paginationTargetConnected() {
    this.intersectionObserver.observe(this.paginationTarget);
  }

  paginationTargetDisconnected() {
    this.intersectionObserver.unobserve(this.paginationTarget);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.loadMore();
      }
    });
  }

  loadMore() {
    // Previne múltiplas chamadas simultâneas
    if (this.loading) return;

    const next = this.paginationTarget.querySelector('[rel=next]');
    if (!next) {
      this.intersectionObserver.unobserve(this.paginationTarget);
      return;
    }

    this.loading = true;
    const href = next.href;

    fetch(href, {
      headers: {
        Accept: 'text/vnd.turbo-stream.html',
      },
    })
      .then((r) => r.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);

        // Mantém o usuário na posição atual usando requestAnimationFrame para garantir que o DOM foi atualizado
        requestAnimationFrame(() => {
          this.loading = false;
        });
      })
      .catch((e) => {
        console.error('Erro ao carregar mais conteúdo:', e);
        this.loading = false;
      });
  }
}
